import { render, staticRenderFns } from "./Cases_part1.vue?vue&type=template&id=6dc6c38c&scoped=true&"
import script from "./Cases_part1.vue?vue&type=script&lang=js&"
export * from "./Cases_part1.vue?vue&type=script&lang=js&"
import style0 from "./Cases_part1.vue?vue&type=style&index=0&id=6dc6c38c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc6c38c",
  null
  
)

export default component.exports